import { Container, Box, Typography } from "@mui/material";
import BackButton from "../components/BackButton";
import NestedOrderTable from "../components/NestedOrderTable";
import RequestBillFooter from "../components/RequestBillFooter";
import React from "react";
import { useEffect } from "react";
import * as ApiCall from '../ApiCall.jsx';

// Loads the bill page which shows a summary of the customers orders and allows them to close the session
// and "request the bill"
function Bill() {
  const [loadState, setLoadState] = React.useState("loading");
  const [orders, setOrders] = React.useState([]);
  const [orderTotal, setOrderTotal] = React.useState(0);
  const cId = localStorage.getItem('customerId');
  const sortedOrders = [...orders].sort((a, b) => new Date(a.startTime) - new Date(b.startTime));
  useEffect(() => {
    if (!cId) {
      setLoadState("nothing");
      return;
    }

    setLoadState("loading");
    ApiCall.get("/customers/orders_totals", "cID="+cId)
    .then((ordersInfo) => {
      setOrderTotal(ordersInfo.total);
      if (ordersInfo.detail && ordersInfo.detail.startsWith("cId error")) {
        setLoadState("nothing");
        return;
      }
      let ordersArray = [];
      Object.keys(ordersInfo).forEach((orderId) => {
        const orderDetails = ordersInfo[orderId];
        if (orderId !== 'total') {
          ordersArray.push(orderDetails);
        }
      });
      setOrders(ordersArray);
      setLoadState("loaded");
    })
    .catch((msg) => {
      alert("Failed to show order, please try again:" + msg);
      setLoadState("nothing");
    })

    if (orders.length === 0) {
      setLoadState("nothing");
    }
  },[]);

  return (
    <>
      <Box sx={{display: 'flex', justifyContent: 'space-between',  flexDirection: 'column', flexWrap: 'nowrap', height: 1, overflowY: "scroll", width: 1}}>
        <Container sx={{mb: 10}}>
          <BackButton sx={{m: 0}}></BackButton>
          <Box sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', mb: 5, mt: 3}}>
            <Typography variant="h2" align="center" sx={{m: "auto"}}>Review Bill</Typography>
          </Box>
          <NestedOrderTable orders={sortedOrders}
          loadState={loadState}></NestedOrderTable>
        </Container>
        {loadState !== 'nothing' && (
          <Container>
            <RequestBillFooter orderTotal={orderTotal} sx={{ bottom: 0 }} />
          </Container>
        )}
      </Box>
    </>
  );
}

export default Bill;
